module.exports = __webpack_public_path__ + "static/media/inktober1 closeup2.ee6cf517.jpg";